"use client";

import { useMemo } from "react";
import { useTranslations } from "@/i18n/client";

export const Translate = ({
  children,
  params,
}: {
  children: string;
  // biome-ignore lint/suspicious/noExplicitAny: translation params are dynamic key-value pairs
  params?: Record<string, any>;
}): string => {
  const t = useTranslations();

  const result = t(children, params);

  const replaceChildren = useMemo(() => {
    if (!params) {
      return result;
    }
    return result.replace(/{{(.*?)}}/g, (_, key) => {
      return params?.[key] || "";
    });
  }, [result, params]);

  return replaceChildren;
};

export const T = Translate;
